import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ShoppingCart, CheckCircle, ArrowRight, Package, TrendingUp, Users, Zap } from 'lucide-react';

const Retail = () => {
  const solutions = [
    {
      icon: <Package className="w-8 h-8" />,
      title: 'Inventory Management',
      description: 'Real-time stock visibility across all locations and channels'
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'Order Fulfillment',
      description: 'Fast, accurate picking and packing for online and in-store orders'
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: 'Demand Forecasting',
      description: 'AI-powered predictions to optimize stock levels'
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Omnichannel Integration',
      description: 'Seamless experience across all sales channels'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center mb-6">
            <ShoppingCart className="w-16 h-16 text-cyan-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Retail & E-commerce Solutions</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto text-center">
            Streamline operations, reduce costs, and deliver exceptional customer experiences
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Retail Solutions</h2>
            <p className="text-lg text-slate-600">Technology that drives retail success</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {solutions.map((solution, index) => (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    <div className="p-3 bg-cyan-100 rounded-lg text-cyan-600">
                      {solution.icon}
                    </div>
                    <CardTitle className="text-xl">{solution.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-600">{solution.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-cyan-600 to-blue-600 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Boost Your Retail Operations</h2>
          <p className="text-xl mb-8 text-cyan-100">
            Discover how we can help you stay competitive in the retail landscape
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-cyan-600 hover:bg-slate-100 px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Get Started <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Retail;